import React from 'react';
import i18next from '../../i18n.js';
import { transportationMethods } from '../../constants.js';
import { confirmChangeDialog } from '../ModalDialog.js';

const iconColor = '#111111';

// Кузов авто з дизайну, опущений вниз, щоб над ним лишилось місце для позначки виду авто
const CarBody = (props) => (<g transform={props.shifted ? 'translate(0 1.5)' : ''}>
    <path d="M4 16v2.5M20 16v2.5M3 15.5l1.4-5A2.5 2.5 0 016.8 8.7h10.4a2.5 2.5 0 012.4 1.8l1.4 5" />
    <path d="M3 15.5h18v-.5a2 2 0 00-2-2H5a2 2 0 00-2 2z" />
    <circle cx="7" cy="14" r=".8" fill={iconColor} stroke="none" />
    <circle cx="17" cy="14" r=".8" fill={iconColor} stroke="none" />
</g>);

// Позначки, якими види авто відрізняються між собою: портфель — корпоративне,
// людина — авто колеги, ключ — оренда
const transportIcons = {
    [transportationMethods.ownCar]: <CarBody />,
    [transportationMethods.corporateCar]: <>
        <CarBody shifted />
        <rect x="14.8" y="3.2" width="7.4" height="5.2" rx="1.2" />
        <path d="M17.2 3.2V2.4h2.6v.8M14.8 5.8h7.4" />
    </>,
    [transportationMethods.autoColleagues]: <>
        <CarBody shifted />
        <circle cx="18.5" cy="3.4" r="1.7" />
        <path d="M15.3 8.4c.3-1.9 1.6-2.9 3.2-2.9s2.9 1 3.2 2.9" />
    </>,
    [transportationMethods.carRental]: <>
        <CarBody shifted />
        <circle cx="16.3" cy="6.2" r="2" />
        <path d="M17.9 4.9L22 1.8M20.4 2.9l1.1 1.4" />
    </>,
    [transportationMethods.bus]: <>
        <rect x="4" y="4" width="16" height="13" rx="3" />
        <path d="M4 12h16M8 4v8M16 4v8" />
        <path d="M6.5 20.5V17M17.5 20.5V17" />
        <circle cx="8" cy="14.5" r=".7" fill={iconColor} stroke="none" />
        <circle cx="16" cy="14.5" r=".7" fill={iconColor} stroke="none" />
    </>,
    [transportationMethods.train]: <>
        <rect x="5" y="3.5" width="14" height="13" rx="3"></rect>
        <path d="M5 11h14M9 3.5v7.5M15 3.5v7.5"></path>
        <circle cx="9" cy="13.7" r=".6" fill="#111" stroke="none"></circle>
        <circle cx="15" cy="13.7" r=".6" fill="#111" stroke="none"></circle>
        <path d="M7.5 20.5L9.5 17M16.5 20.5L14.5 17"></path>
    </>,
    [transportationMethods.plane]: <>
        <path fill="none" stroke="#111" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M21 15.5l-8-2-3.5 5-1.7-.5 1.5-5.4-4.3-1.1-1.6 2-1.4-.4L3 10l1.5-1.6 1.4.4.8 2.2 4.3 1.1L12.6 8l1.7.5-.9 5.2 8 2z"></path>
    </>
}

const TransportIcon = (props) => (
    <svg width={props.size ?? 22} height={props.size ?? 22} viewBox="0 0 24 24" fill="none" stroke={iconColor} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        {transportIcons[props.transport] ?? <CarBody />}
    </svg>
);
const ChevronRightIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#B4B4B4" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 5l7 7-7 7" />
    </svg>
);

// Вид транспорту: доки не обрано — список усіх варіантів, після вибору лишається
// тільки обраний варіант з кнопкою зміни, яка скидає значення після підтвердження.
const TransportSelectInput = (props) => {
    const { name, value, values, disabled } = props;

    const options = values?.data?.filter(item => !item.hidden) ?? [];
    const selected = options.find(item => item.value === value);

    const changeValue = (newValue) => {
        if (props.onChange) {
            props.onChange({
                target: {
                    name: name,
                    value: newValue
                }
            });
        }
    }

    const changeHandle = () => {
        confirmChangeDialog(
            i18next.t('form.fields.transportConfirmTitle'),
            i18next.t('form.fields.transportConfirmText'),
            i18next.t('form.fields.transportConfirmYes'),
            () => changeValue(''));
    }

    return (<div className={'transport-select' + (disabled ? ' disabled' : '')} id={name} name={name} >
        {selected
            ? <div className="transport-select-selected">
                <TransportIcon transport={selected.value} size={24} />
                <span>{selected.label}</span>
                {!disabled && <button type="button" className="transport-select-change" onClick={changeHandle}>
                    {i18next.t('form.fields.transportChangeBtn')}
                </button>}
            </div>
            : <div className="transport-select-items">
                {options.map(item =>
                    <div className="transport-select-item" key={item.value} onClick={() => { if (!disabled) changeValue(item.value) }}>
                        <TransportIcon transport={item.value} />
                        <span>{item.label}</span>
                        <ChevronRightIcon />
                    </div>
                )}
            </div>}
    </div>);
}

export default TransportSelectInput;
